import { axiosGet } from 'shared/api/axios'
import { apiUrls, connectionTypes } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'
import { NavLink } from 'react-router-dom'
import { IonIcon } from '@ionic/react'
import { sendOutline } from 'ionicons/icons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
  filter?: object
  testConnection: Function
  setShowOverlay: Function
}

const getRows = async (props: getRowsProps) => {
  const getParams = {}

  const response = await axiosGet(apiUrls.connections, getParams)

  const data = response.data

  data.forEach((row: any, index: number, dataArray: any) => {
      dataArray[index].action = (
        <ActionButtons
          buttons={[
            {
              type: 'u',
              url: '/edit-connection/' + row.id
            },
            {
              type: 'p',
              id: dataArray[index].id,
              url: '/change-connection-password/' + row.id,
              setDeleteEntryId: props.setDeleteEntryId,
              setShowModal: props.setShowModal,
            },
            {
            content: (
              <NavLink
                to='#'
                title='Test Connection'
                onClick={(e) => {
                  props.testConnection({id: row.id, setShowOverlay: props.setShowOverlay})
                }}
              >
                <IonIcon icon={sendOutline} className='ionicon' style={{ fontSize: '16px' }} />
              </NavLink>
            ),
          },
            {
              type: 'd',
              id: dataArray[index].id,
              url: '/delete-connection/' + row.id,
              setDeleteEntryId: props.setDeleteEntryId,
              setShowModal: props.setShowModal
            }
          ]}
        />
      )

      dataArray[index].active = dataArray[index].active === 1 ? 'Yes' : 'No'
      dataArray[index].type = connectionTypes.find(t => t.id === dataArray[index].type)?.name
  })

  return data
}

export default getRows
